import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RootcategoriesService } from '../rootcategories/rootcategories.service';
import { Subscription } from 'rxjs';
import { NodeService } from 'src/app/services/node-service/node-service.service';
import { MatDialogRef } from '@angular/material/dialog';

// Definir la interfaz CategoriesNode aquí o importarla si ya está en un archivo compartido
interface CategoriesNode {
  id: number;
  nombre: string;
  children?: CategoriesNode[];
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  standalone: false,
})
export class DialogComponent implements OnInit {
  subscriptionCategoriesList: Subscription = new Subscription();
  data: CategoriesNode[] = []; // <--- CAMBIO: Tipar la propiedad 'data' como un array de CategoriesNode
  poisToMove: number[] = [];
  @Output() idSelected = new EventEmitter<number>();

  constructor(
    private rootcategoriesService: RootcategoriesService,
    private readonly nodeService: NodeService,
    private readonly dialogRef: MatDialogRef<DialogComponent>
  ) {}

  ngOnInit(): void {
    this.subscriptionCategoriesList = this.rootcategoriesService.listCategories().subscribe({
      next: (response) => {
        // Asegurarse de que response.body sea un array de CategoriesNode
        this.data = response.body;
      },
      error: (error) => {
        // Aquí se maneja el error. DialogComponent no llama openSnacBar directamente.
      },
    });
    this.poisToMove = this.nodeService.getPoisToMove();
  }

  handleSelected(id: number) {
    this.nodeService.setDestinationCategory(id);
    this.idSelected.emit(id);
  }

  movePois() {
    this.dialogRef.close(true);
  }
}
